import React from 'react'
import { Container, Form, Button, Image, Row, Col, Nav, NavDropdown } from 'react-bootstrap';
import SideNav from '../components/SideNav';
import StepProgress from '../components/StepProgress';
import OrdersPage from './OrderPage';
import ProjectList from '../components/ProjectList';
import NotificationDropdown from '../components/NotificationDropdown'; // New notification component

function ProjectDashboard() {
  const userUId = window.localStorage.getItem('projectUserUID');
  const userRole = window.localStorage.getItem('projectUserRole');
 
    const projectSteps = [
        'Project Initiation',
        'Planning',
        'Execution',
        'Monitoring',
        'Closure'
      ];
      const currentStep = 3;
    return (
        <Container fluid className='p-3' style={{ backgroundColor: "#F9FAFB", height: "100vh", }}>
            <Row>
                <Col className='col-auto'>
                   <SideNav />
                </Col>
                <Col style={{ padding: "0px 10px 0px 20px",flexGrow:1}}>
                    <Row className='p-2' style={{ backgroundColor: "#fff", borderRadius: '10px', alignItems: "center", justifyContent: "spaceBetween" }}>
                        <Col><h4 style={{ color: "#000" }}>Project Dashboard</h4></Col>
                        <Col className="d-flex justify-content-end align-items-center">
                        {/* <NotificationDropdown userId={userUId} /> */}
                            {/* <Image src={require('../assets/notification.png')} roundedCircle style={{ width: '25px', height: 'auto', marginRight: '5px', }} /> */}
                            <Image src={require('../assets/user.jpg')} roundedCircle style={{ width: '40px', height: 'auto' }} />
                        </Col>
                    </Row>
                    <Row className='p-2 mt-2' style={{ backgroundColor: "#fff", borderRadius: '10px', alignItems: "center", justifyContent: "spaceBetween", overflowY: 'auto', minHeight: '88vh', maxHeight: '88vh'  }}>
                        {/* <Col><h5 style={{ color: "white" }}>Project List</h5></Col>
                         */}
                         <OrdersPage userId={userUId} role={userRole}  />
                         {/* <ProjectList userId="UDQDqYLRhhUMbqnjcMh1nfzWWU82" role="salesperson"  /> */}

                      
                    </Row>

                </Col>
            </Row>
        </Container>
    )
}

export default ProjectDashboard